<template>
  <div class="archive20231003" v-if="info">
    <v-container>
      <div v-for="(info, index) in info" :key="index">
        <v-row class="mt-4 text-h6" justify="center">
          <v-col cols="10" xl="8">
            <div class="heading text-h4 pl-4">{{ formatDate(info.date) }} 言語処理学会第32回年次大会 参加報告</div>
          </v-col>
        </v-row>

        <v-row class="mt-4 text-h8" justify="center">
          <v-col cols="8" xl="6">
            <div>
              <div class="text-h8">2026年3月9日から13日にかけて, 栃木県宇都宮市で開催された言語処理学会第32回年次大会(NLP2026)に参加してきました.</div>
            </div>
          </v-col>
        </v-row>

        <v-row class="mt-4 text-h6" justify="center">
          <v-col cols="9" xl="7">
            <v-row class="my-4" justify="center">
                <v-col cols="12" md="8">
                    <v-img
                    :src="require(`@/assets/archives_images/20260309_1.jpg`)"
                    eager
                    ></v-img>
                    <v-img
                    :src="require(`@/assets/archives_images/20260309_2.png`)"
                    eager
                    ></v-img>
                </v-col>
            </v-row>
          </v-col>
        </v-row>
        
        <v-row class="mt-4 text-h6" justify="center">
          <v-col cols="9" xl="7">
            <div>
              <div class="text-h6">活発な議論が飛び交ったポスター発表 </div>
            </div>
          </v-col>
        </v-row>

        <v-row class="mt-4 text-h8" justify="center">
          <v-col cols="8" xl="6">
            <div>
              <div class="text-h8">
                私は今回、『大規模言語モデルの自己修正における「盲点」の定量化とタスク特性に応じた介入手法の分析』についてポスター形式で発表を行いました。<br><br>

                ポスターセッションは想像以上にエネルギッシュで、学生だけでなく、企業のエンジニアの方や他大学の教授など、多方面から貴重なフィードバックをいただくことができました。<br>
                特に印象的だったのは、似た領域を研究している方々との交流です。自分の研究へのアドバイスをいただくだけでなく、こちらからも積極的に質問を投げかけることで、多くの知見を得ることができました。
              </div>
            </div>
          </v-col>
        </v-row>

        <v-row class="mt-4 text-h6" justify="center">
          <v-col cols="9" xl="7">
            <v-row class="my-4" justify="center">
                <v-col cols="12" md="8">
                    <v-img
                    :src="require(`@/assets/archives_images/20260309_3.jpg`)"
                    eager
                    ></v-img>
                </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-row class="mt-4 text-h6" justify="center">
          <v-col cols="9" xl="7">
            <div>
              <div class="text-h6">学会ならではの雰囲気と企業交流 </div>
            </div>
          </v-col>
        </v-row>

        <v-row class="mt-4 text-h8" justify="center">
          <v-col cols="8" xl="6">
            <div>
              <div class="text-h8">
                今回の学会は非常にフランクな雰囲気で、会場内では軽食やドリンクも振る舞われていました。リラックスした環境だったからこそ、初対面の方とも深い議論ができたと感じています。<br><br>

                また、会場には多くの企業ブースも併設されていました。現場で活躍するプロの視点に触れることができ、研究の社会実装やキャリアパスを考える上でも、非常に有益な場でした。
              </div>
            </div>
          </v-col>
        </v-row>

        <v-row class="mt-4 text-h6" justify="center">
          <v-col cols="9" xl="7">
            <v-row class="my-4" justify="center">
                <v-col cols="12" md="8">
                    <v-img
                    :src="require(`@/assets/archives_images/20260309_4.jpg`)"
                    eager
                    ></v-img>
                </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-row class="mt-4 text-h6" justify="center">
          <v-col cols="9" xl="7">
            <div>
              <div class="text-h6">宇都宮の味覚を満喫 </div>
            </div>
          </v-col>
        </v-row>

        <v-row class="mt-4 text-h8" justify="center">
          <v-col cols="8" xl="6">
            <div>
              <div class="text-h8">
                そして、宇都宮開催といえば外せないのが「餃子」です！<br>
                滞在中は毎日のように色々なお店の餃子を堪能しました。研究の議論で頭を使い果たした後の餃子は格別で、まさに心身ともにリフレッシュできた5日間でした。
              </div>
            </div>
          </v-col>
        </v-row>

        <v-row class="mt-4 text-h6" justify="center">
          <v-col cols="9" xl="7">
            <v-row class="my-4" justify="center">
                <v-col cols="12" md="8">
                    <v-img
                    :src="require(`@/assets/archives_images/20260309_5.jpg`)"
                    eager
                    ></v-img>
                </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-row class="mt-4 text-h6" justify="center">
          <v-col cols="9" xl="7">
            <div>
              <div class="text-h6">最後に </div>
            </div>
          </v-col>
        </v-row>

        <v-row class="mt-4 text-h8" justify="center">
          <v-col cols="8" xl="6">
            <div>
              <div class="text-h8">
                今回の学会で得た刺激を糧に、残り少ない学生生活での研究活動をより一層加速させていきたいと思います。<br>
                議論してくださった皆様、そしてこのような機会をくださった先生に感謝いたします。
              </div>
            </div>
          </v-col>
        </v-row>

      </div>
    </v-container>
  </div>
</template>

<script>
// 共通のJavaScriptファイルをインポート
import commonScript from "./common/CommonScript.js";

export default {
  mixins: [commonScript], // 共通スクリプトをミックスイン
};
</script>

<style scoped>
/* 共通のCSSファイルをインポート */
@import url("./common/CommonStyles.css");
</style>